import Modal from "~/components/Modal/Modal";

const WebViewSessionExpiredPopup = () => {
  return (
    <Modal
      visible
      onClose={() => {}}
      title="Session Expired"
      hideCancel
      hideConfirm
      bodyText="Your session has expired, please press the close button in the top left and try again."
    />
  );
};

export default WebViewSessionExpiredPopup;
